import React from "react";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _2200px,
  _576px,
  _450px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { baseUrl } from "../../utils/base_url";
import { Carousel } from "react-bootstrap";

const Solo_PractitionersTopUpdated = ({
  leftbg,
  heading,
  subHeading,
  imgsrc,
}) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });
  return (
    <>
      <div className="container-fluid m-0 p-0">
        <div className="row">
          <div
            className="col-12 col-lg-6 d-flex flex-column justify-content-center gap-3"
            style={{
              height: _992 ? "50vh" : "95vh",
              backgroundColor: `${leftbg}`,
              paddingLeft: _450
                ? "1.8rem"
                : _576
                ? "2.5rem"
                : _768
                ? "3rem"
                : _992
                ? "4rem"
                : _1200
                ? "8rem"
                : _1400
                ? "9.5rem"
                : _1500
                ? "9.8rem"
                : _1600
                ? "10.6rem"
                : _1700
                ? "11.2rem"
                : _1800
                ? "11.8rem"
                : "12.6rem",
            }}
          >
            <p
              className="text-white fw900 py-0 my-0 lh-sm"
              style={{
                fontSize: _576
                  ? "25px"
                  : _768
                  ? "35px"
                  : _992
                  ? "34px"
                  : _1200
                  ? "34px"
                  : _1400
                  ? "40px"
                  : _1600
                  ? "45px"
                  : _1700
                  ? "50px"
                  : _1800
                  ? "50px"
                  : "60px",
                paddingRight: _450
                  ? "1.8rem"
                  : _576
                  ? "2.5rem"
                  : _768
                  ? "3rem"
                  : _992
                  ? "4rem"
                  : _1200
                  ? "3rem"
                  : _1400
                  ? "6.7rem"
                  : _1500
                  ? "7.5rem"
                  : _1600
                  ? "8rem"
                  : _1700
                  ? "6.8rem"
                  : _1800
                  ? "9.4rem"
                  : "5.8rem",
              }}
            >
              {/* Maximize your practice efficiency Achieve more with Ask Fides */}
              {heading}
            </p>
            <p
              className={`text-white fw400 py-0 my-0 ${
                _576 ? "lh-sm" : "lh-1"
              }`}
              style={{
                fontSize: _576
                  ? "14px"
                  : _768
                  ? "16px"
                  : _992
                  ? "22px"
                  : _1200
                  ? "17px"
                  : _1400
                  ? "19px"
                  : _1600
                  ? "22px"
                  : _1700
                  ? "28px"
                  : _1800
                  ? "28px"
                  : "35px",
                paddingRight: _450
                  ? "1.8rem"
                  : _576
                  ? "2.5rem"
                  : _768
                  ? "3rem"
                  : _992
                  ? "4rem"
                  : _1200
                  ? "4rem"
                  : _1400
                  ? "12.2rem"
                  : _1500
                  ? "11.5rem"
                  : _1600
                  ? "7rem"
                  : _1700
                  ? "6.5rem"
                  : _1800
                  ? "11.3rem"
                  : "6.5rem",
              }}
            >
              {/* Operate at your highest potential with precision legal
              intelligence. Ask Fides delivers real-time insights through a
              trusted, hallucination-free workflow - designed to enhance
              accuracy, speed, and control. */}
              {subHeading}
            </p>
          </div>
          <div
            className="col-12 col-lg-6 m-0 p-0"
            style={{
              backgroundColor: " #283950",
              height: _992 ? "50vh" : "95vh",
            }}
          >
            {/* <Carousel
              pause={false}
              indicators={false}
              interval={5000}
              controls={false}
            >
              {imgsrc?.map((image, idx) => (
                <Carousel.Item key={idx} className="position-relative vh-100">
                  {image?.mime?.includes("video") ? (
                    <div style={{ height: "100%", width: "100%" }}>
                      <video
                        autoPlay
                        loop
                        muted
                        style={{
                          objectFit: "cover",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <source
                          src={`${baseUrl}${image?.url}`}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : (
                    <img
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={`${baseUrl}${image?.url}`}
                      alt="..."
                    />
                  )}
                </Carousel.Item>
              ))}
            </Carousel> */}
            {/* {imgsrc?.mime?.includes("video") ? (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <video
                  autoPlay
                  loop
                  muted
                  className=""
                  style={{
                    objectFit: "cover",
                    height: "100%",
                    width: "100%",
                    // borderRadius: "20px",
                  }}
                >
                  <source src={`${baseUrl}${imgsrc?.url}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              <img
                className="d-block"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  // borderRadius: "20px",
                }}
                src={`${baseUrl}${imgsrc?.url}`}
                alt="..."
              />
            )} */}
            {/* {imgsrc?.length === 1 ? (
              imgsrc[0]?.mime?.includes("video") ? (
                <div style={{ height: "100%", width: "100%" }}>
                  <video
                    autoPlay
                    loop
                    muted
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <source
                      src={`${baseUrl}${imgsrc[0]?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <img
                  style={{ objectFit: "cover", width: "100%", height: "100%" }}
                  src={`${baseUrl}${imgsrc[0]?.url}`}
                  alt="..."
                />
              )
            ) : (
              <Carousel
                pause={false}
                indicators={false}
                interval={5000}
                controls={false}
              >
                {imgsrc?.map((image, idx) => (
                  <Carousel.Item key={idx} className="position-relative vh-100">
                    {image?.mime?.includes("video") ? (
                      <div style={{ height: "100%", width: "100%" }}>
                        <video
                          autoPlay
                          loop
                          muted
                          style={{
                            objectFit: "cover",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <source
                            src={`${baseUrl}${image?.url}`}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ) : (
                      <img
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={`${baseUrl}${image?.url}`}
                        alt="..."
                      />
                    )}
                  </Carousel.Item>
                ))}
              </Carousel>
            )} */}
            {imgsrc?.column_view?.column_childs?.[0]?.image?.length === 1 ? (
              imgsrc?.column_view?.column_childs[0]?.image[0]?.mime?.includes(
                "video"
              ) ? (
                <div style={{ height: "100%", width: "100%" }}>
                  <video
                    autoPlay
                    loop
                    muted
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <source
                      src={`${baseUrl}${imgsrc?.column_view?.column_childs[0]?.image[0]?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <img
                  style={{ objectFit: "cover", width: "100%", height: "100%" }}
                  src={`${baseUrl}${imgsrc?.column_view?.column_childs[0]?.image[0]?.url}`}
                  alt="..."
                />
              )
            ) : (
              <Carousel
                pause={false}
                indicators={false}
                interval={5000}
                controls={false}
              >
                {imgsrc?.column_view?.column_childs[0]?.image?.map(
                  (image, idx) => (
                    <Carousel.Item
                      key={idx}
                      className="position-relative vh-100"
                    >
                      {image?.mime?.includes("video") ? (
                        <div style={{ height: "100%", width: "100%" }}>
                          <video
                            autoPlay
                            loop
                            muted
                            style={{
                              objectFit: "cover",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <source
                              src={`${baseUrl}${image?.url}`}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <img
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          src={`${baseUrl}${image?.url}`}
                          alt="..."
                        />
                      )}
                    </Carousel.Item>
                  )
                )}
              </Carousel>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Solo_PractitionersTopUpdated;
